<template>
  <div class="">
    <img
      :src="require('@/assets/news/newsbanner.png')"
      alt="Carousel Image"
      style="display: inline-block; width: 100%"
    />
    <!-- 面包屑 -->
    <!-- <div class="x-help-bread">
      首页 <i class="el-icon-arrow-right x-help-icon"></i> 
      新闻资讯
    </div> -->
    <!-- 新闻 -->
    <div class="news">
      <div class="news-item" v-for="(item,index) in newsList" :key="index" @click="goToNewsDetail(index)">
        <div class="news-item-r">
          <img :src="item.img" alt="">
        </div>
        <div class="news-item-l">
          <div class="news-item-l-title">{{ item.title }}</div>
          <div class="news-item-l-content">{{ item.brief }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { newsList } from "@/common/news";
export default {
  data() {
    return {
      newsList: newsList()
    };
  },
  methods: {
    goToNewsDetail(num){
      this.$router.push({ path: '/newsDetail', query: { num } });
    },
  },
};
</script>
<style lang="scss" scoped>
  .x-help-bread {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    background: #00AECF ;
    box-sizing: border-box;
    padding-left: 10%;
    color: #fff;
    font-size: 14px;
    .x-help-icon {
      padding: 0 5px;
      margin-top: 3px;
    }
  }
  .news{
    width: 80%;
    min-width: 1200px;
    margin: 40px auto;
    .news-item{
      width: 100%;
      height: 160px;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      .news-item-l{
        flex: 1;
        box-sizing: border-box;
        padding: 10px 20px;
        .news-item-l-title{
          font-size: 18px;
          text-align: left;
          line-height: 32px;
          color: #00AECF ;
          margin: 10px 0;
        }
        .news-item-l-content{
          font-size: 14px;
          text-align: left;
          line-height: 20px;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .news-item-r{
        width: 200px;
        height: 100%;
        margin-right: 20px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 150px;
          height: 82px;
          border-radius: 8px;
        }
      }
    }
  }
</style>
